import _ from 'lodash'

export default function getFilteredEventsForCategories(events, activeCategories) {
  return _.filter(events, (event) => _.intersection(activeCategories, event?.categories).length > 0)
}
